function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M-57.654 267.573h32.523v26.609h-32.523z"
}), /*#__PURE__*/React.createElement("path", {
  id: "d",
  d: "M-22.175 286.791h38.436v16.261h-38.436z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M-60.476 6.804h294.821v184.452H-60.476z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0092b2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.706
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6380ae"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6380ae",
  stopOpacity: 0
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "small-cloud",
  d: "M110.11 246.725c6.148-11.24-4.152-16.228-11.12-19.879-4.098-21.224-51.253-33.51-46.68-8.674-.913-4.3-19.371-11.178-22.619 2.238-7.543-2.69-19.906 2.832-15.258 16.404 4.647 13.571 22.935 12.77 25.511 8.096-6.162 6.629-1.244 15.85 7.975 20.747 9.22 4.896 23.204 7.223 31.618 2.564 8.414-4.658 7.143-10.79 6.34-15.894 0 0 18.912 4.123 24.232-5.602z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "small-cloud",
  d: "M110.11 246.725c6.148-11.24-4.152-16.228-11.12-19.879-3.227-16.898-48.677-36.728-46.68-8.674-.913-4.3-19.371-11.178-22.619 2.238-7.543-2.69-19.906 2.832-15.258 16.404 4.647 13.571 22.935 12.77 25.511 8.096-6.162 6.629-1.244 15.85 7.975 20.747 9.22 4.896 23.205 7.223 31.618 2.564 8.414-4.658 7.143-10.79 6.34-15.894 0 0 18.912 4.123 24.232-5.602z",
  fill: "none",
  stroke: "#1d5566",
  strokeWidth: 3.159,
  strokeOpacity: 0.855
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "small-cloud",
  d: "M50.5 258.464c5.873 13.435 33.426 6.968 29.684-1.776-8.887-10.022-13.84 3.693-29.684 1.776z",
  fill: "#e4e4e4"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "sun",
  cx: 109.978,
  cy: 225.232,
  r: 48.302,
  fill: "#ffed18"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "sun",
  d: "M109.97 176.91c54.683 27.836 36.782 81.255 2.126 97.22 33.798-3.27 43.349-24.175 46.22-49.939-3.957-24.445-14.838-43.945-48.345-47.282z",
  fill: "#ffd418"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  id: "sun",
  r: 48.302,
  cy: 225.534,
  cx: 110.182,
  fill: "none",
  stroke: "#df8b1e",
  strokeWidth: 3.265
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "sun",
  d: "M92.09 194.9c2.573 23.188-5.941 11.586-15.944 45.633-10.414-2.49 13.37-68.82 15.944-45.633z",
  fill: "#fff68c"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  id: "rays",
  cx: 110.275,
  cy: 226.019,
  r: 59.762,
  fill: "none",
  stroke: "#fff68c",
  strokeWidth: 4.04
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  id: "rays",
  ry: 71.949,
  rx: 71.121,
  cy: 225.579,
  cx: 110.468,
  fill: "none",
  stroke: "#fff68c",
  strokeWidth: 3.018,
  strokeOpacity: 0.564
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "big-cloud",
  d: "M136.841 236.763c-3.617 19.929 12.557 23.423 23.616 26.214 11.385 24.125 74.642 9.967 67.386-5.735 3.072 6.285 31.181 9.356 29.915-12.752 11.436 1.069 25.962-12.557 13.856-31.663s-36.721-10.356-38.252-2.061c5.593-12.795-5.034-25.055-19.695-28.85-14.661-3.797-34.733-1.657-44.236 9.01-9.504 10.668-5.164 19.642-1.9 27.214 0 0-27.56 1.38-30.69 18.623z",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "big-cloud",
  d: "M136.841 236.763c-3.617 19.929 12.557 23.423 23.616 26.214 11.385 24.125 74.642 9.967 67.386-5.735 3.072 6.285 31.181 9.356 29.915-12.752 11.436 1.069 25.962-12.557 13.856-31.663s-36.721-10.356-38.252-2.061c5.593-12.795-5.034-25.055-19.695-28.85-14.661-3.797-34.733-1.657-44.236 9.01-9.504 10.668-5.164 19.642-1.9 27.214 0 0-27.56 1.38-30.69 18.623z",
  fill: "none",
  stroke: "#1c5464",
  strokeWidth: 3.265,
  strokeOpacity: 0.847
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "big-cloud",
  d: "M181.234 258.89c8.954 18.793 48.372 3.555 42.666-8.676 2.416 4.896 28.732 6.523 27.736-10.698 8.994.832 26.54-4.807 17.02-19.69-9.522-14.883-28.88-8.067-30.085-1.606 9.974 4.475-9.479 20.307-24.643 2.148 17.577 38.865-24.482 39.686-32.694 38.523z",
  fill: "#e4e4e4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "rays",
  d: "M2.3 182.668l57.665 26c.749-3.488 1.12-4.044 1.637-5.245zM29.306 143.86l41.755 47.514c2.125-2.867 2.693-3.22 3.66-4.1zM64.233 120.068l22.113 59.263c3.006-1.923 3.662-2.05 4.88-2.528zM108.396 110.034l-1.985 63.224c3.51-.642 4.166-.51 5.474-.492zM157.209 119.83l-22.113 59.263c-3.006-1.923-3.662-2.05-4.88-2.529zM196.6 147.26l-41.756 47.515c-2.124-2.867-2.692-3.219-3.66-4.1zM-4.311 225.099l63.21 2.367c-.62-3.514-.485-4.17-.459-5.477zM3.882 270.246l57.664-26c.75 3.488 1.121 4.044 1.638 5.245z",
  fill: "#ffed18"
});

var SvgMinimaltitle = function SvgMinimaltitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "-110 125 200 250",
    height: "400px",
    width: "300px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.91395 1.09415)",
    y: 300.585,
    x: 34.837,
    style: {
      lineHeight: 0
    },
    fontWeight: 400,
    fontSize: 50.67,
    fontFamily: "sans-serif",
    letterSpacing: 0.01,
    fill: "#ffff",
    fillOpacity: 0.914,
    strokeWidth: 0.257
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 300.585,
    x: 34.837,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Black, Heavy'"
    },
    fontWeight: 900,
    fontSize: 41.084,
    fontFamily: "Arial Black",
    letterSpacing: 1.027
  }, "TRENDING"), /*#__PURE__*/React.createElement("tspan", {
    style: {
      lineHeight: 0.9,
      InkscapeFontSpecification: "'Arial Narrow'"
    },
    y: 336.805,
    x: 34.837,
    fontSize: 36.975,
    fontFamily: "Arial Narrow",
    letterSpacing: 0.018
  }, "TEMPERATURES")));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMinimaltitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minimaltitle.9f589df5.svg";
export { ForwardRef as ReactComponent };